const ActionTypes = {
  SET_USER_TYPE: "SET_USER_TYPE",
  SET_USER_PERSONAL_INFO: "SET_USER_PERSONAL_INFO",
  SET_USER_CREDENTIALS: "SET_USER_CREDENTIALS",
  SET_REGISTRATION_STEP: "SET_REGISTRATION_STEP",
  CLEAR_NEW_REGISTRATION_DATA: "CLEAR_NEW_REGISTRATION_DATA",
  SET_TC_AND_PP_TO_NEW_REGISTRATION_DATA:
    "SET_TC_AND_PP_TO_NEW_REGISTRATION_DATA",
  SET_PAYMENT_REDIRECT_LINK: "SET_PAYMENT_REDIRECT_LINK",
};

function setUserType(payload = null) {
  return {
    type: ActionTypes.SET_USER_TYPE,
    payload,
  };
}

function setUserPersonalInfo(payload = null) {
  return {
    type: ActionTypes.SET_USER_PERSONAL_INFO,
    payload,
  };
}

function setUserCredentials(payload = null) {
  return {
    type: ActionTypes.SET_USER_CREDENTIALS,
    payload,
  };
}

function setRegistrationStep(payload = null) {
  return {
    type: ActionTypes.SET_REGISTRATION_STEP,
    payload,
  };
}

function setTCandPP(payload = null) {
  return {
    type: ActionTypes.SET_TC_AND_PP_TO_NEW_REGISTRATION_DATA,
    payload,
  };
}

function clearNewRegistrationData() {
  return {
    type: ActionTypes.CLEAR_NEW_REGISTRATION_DATA,
  };
}

function setPaymentRedirectLink(payload = "") {
  return {
    type: ActionTypes.SET_PAYMENT_REDIRECT_LINK,
    payload,
  };
}

export {
  setUserType,
  setRegistrationStep,
  setUserCredentials,
  setUserPersonalInfo,
  clearNewRegistrationData,
  setTCandPP,
  ActionTypes,
  setPaymentRedirectLink,
};



// WEBPACK FOOTER //
// ./src/js/store/actions/newRegistration.js